import React from 'react';
import { Link } from 'react-router-dom';
import { HiExclamationTriangle } from 'react-icons/hi2';

export const PLANS_PATH = '/user-settings/subscription/plans';
const DEFAULT_MESSAGE = 'Your plan’s AI usage limit for this billing period is reached. Upgrade to keep using Copilot.';

const isBlocked = aiUsage => Boolean(aiUsage && aiUsage.blocked);

/** Header label shown while the account's AI usage cap is reached. */
export function AiUsageLimitLabel({ aiUsage }) {
    if (!isBlocked(aiUsage)) return null;
    return (
        <span
            title={aiUsage.message || DEFAULT_MESSAGE}
            className="flex items-center gap-1 whitespace-nowrap rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-medium text-amber-800 dark:bg-amber-900/40 dark:text-amber-200"
        >
            <HiExclamationTriangle className="h-3.5 w-3.5" /> AI usage limit reached
        </span>
    );
}

/** The cap's explanation above the composer, with the way out. */
export function AiUsageLimitNotice({ aiUsage }) {
    if (!isBlocked(aiUsage)) return null;
    return (
        <div role="status" className="mb-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900 dark:border-amber-800/60 dark:bg-amber-900/20 dark:text-amber-100">
            {aiUsage.message || DEFAULT_MESSAGE}{' '}
            <Link to={PLANS_PATH} className="font-semibold underline">Upgrade plan</Link>
        </div>
    );
}
